<div class="serprobots-main-content">
    <section>
        <serprobots-header
            (onClose)="onClose()"
            (onMinimize)="onMinimize()">
        </serprobots-header>
    </section>

    <div #messagesElementRef class="serprobots-main-messages-content" [style.background-color]="configuration.messageListBackgroundColor"
        [class.testWatermark]="!configuration.isProductive">
        <serprobots-messages-list
            [conversation]="conversation"
            (requestSendText)="onRequestSendText($event)"
            (optionSelected)="onOptionSelected($event)">
        </serprobots-messages-list>
     </div>

     <footer [style.color]="configuration.footerColor" [style.background-color]="configuration.footerBackgroundColor" fxLayoutAlign="center center" flex="none" class="serprobots-main-footer-content">
        <serprobots-message-input
            *ngIf="!showAssesment"
            [disabled]="disableInputs"
            [showAssesmentButton]="showAssesmentButton && enableAssesment"
            [usePassword]="usePasswordInput"

            (onRestart)="onRestart($event)"
            (onShowAssesment)="onShowAssesment()"
            (onNewUserMessage)="onNewUserMessage($event)">
        </serprobots-message-input>

        <serprobots-assesment *ngIf="showAssesment && enableAssesment"
            (onLikeClicked)="onLikeClicked()"
            (onDislikeClicked)="onDislikeClicked()">
        </serprobots-assesment>
     </footer>

</div>
